
import { createContext } from "react";

const ContextUserGroup = createContext({});

export default ContextUserGroup